import TableCell from '@mui/material/TableCell';
import ActionCell from './ActionCell';
import ReqActionCell from './ReqActionCell';
import InviteActionCell from './InviteActionCell';

const CustomCell = ({ column, value, row }) => {
  const { id } = column;

  if (id === 'user_actions') {
    return (
      <ActionCell
        userId={row.user_id}
      />
    );
  }

  if (id === 'req_actions') {
    return (
      <ReqActionCell
        reqId={row.request_id}
      />
    );
  }

  if (id === 'invite_actions') {
    return (
      <InviteActionCell
        actionId={row.action_id}
      />
    );
  }

  if (id === 'last_login' || id === 'start') {
    const formattedDate = new Date(value).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    });
    return (
      <TableCell
        align="left"
        sx={{ color: '#22467F', padding: '4px', width: 'auto', whiteSpace: 'nowrap', overflow: 'hidden' }}
      >
        {formattedDate}
      </TableCell>
    );
  }
  if (id === 'end') {
    const date1 = new Date(row.start);
    const date2 = new Date();
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return (
      <TableCell
        align="left"
        sx={{ color: '#22467F', padding: '4px' }}
      >
        {diffDays || 0}
      </TableCell>
    );
  }

  if (id === 'expire') {
    const start = new Date(row.start);
    const expire = new Date(row.expire);
    const diffTime = Math.abs(expire - start);
    const timeToExpire = Math.ceil(diffTime / (1000 * 60 * 60));
    return (
      <TableCell
        align="left"
        sx={{ color: '#22467F', padding: '4px' }}
      >
        {timeToExpire || 0}
      </TableCell>
    );
  }

  return (
    <TableCell
      align="left"
      sx={{ color: '#22467F', padding: '4px' }}
    >
      {value}
    </TableCell>
  );
};

export default CustomCell;
